import type { RendererProps } from '@quromedical/utils/ui';
import { Text } from 'design-system/base';
import type { Node } from 'markdown-ast';
import { View } from 'react-native';

const getText = (node: Node): string => {
  return 'text' in node && typeof node.text === 'string' ? node.text : '';
};

export const renderers = {
  text: ({ node }: RendererProps) => <Text>{getText(node)}</Text>,
  bold: ({ node, children }: RendererProps) => (
    <Text style={{ fontWeight: 'bold' }}>{children || getText(node)}</Text>
  ),
  italic: ({ node, children }: RendererProps) => (
    <Text style={{ fontStyle: 'italic' }}>{children || getText(node)}</Text>
  ),
  underline: ({ node, children }: RendererProps) => (
    <Text style={{ textDecorationLine: 'underline' }}>
      {children || getText(node)}
    </Text>
  ),
  strike: ({ node, children }: RendererProps) => (
    <Text style={{ textDecorationLine: 'line-through' }}>
      {children || getText(node)}
    </Text>
  ),
  link: ({ node }: RendererProps) => (
    <Text style={{ color: 'blue', textDecorationLine: 'underline' }}>
      {getText(node)}
    </Text>
  ),
  title: ({ node, children }: RendererProps) => (
    <Text style={{ fontSize: 24, fontWeight: 'bold', marginVertical: 8 }}>
      {children || getText(node)}
    </Text>
  ),
  break: ({ key }: RendererProps) => {
    return <View key={key} style={{ height: 12 }} />;
  },
  list: ({ children }: RendererProps) => (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginVertical: 4,
        marginLeft: 16,
      }}
    >
      <Text style={{ marginRight: 6, lineHeight: 20, fontSize: 18 }}>
        {'\u2022'}
      </Text>
      <View style={{ flex: 1 }}>{children}</View>
    </View>
  ),
  codeBlock: ({ node }: RendererProps) => (
    <View style={{ backgroundColor: '#f0f0f0', padding: 8, borderRadius: 4 }}>
      <Text style={{ fontFamily: 'monospace' }}>{getText(node)}</Text>
    </View>
  ),
  codeSpan: ({ node }: RendererProps) => (
    <Text
      style={{
        fontFamily: 'monospace',
        backgroundColor: '#f0f0f0',
        padding: 2,
      }}
    >
      {getText(node)}
    </Text>
  ),
  quote: ({ children }: RendererProps) => (
    <View
      style={{
        borderLeftWidth: 4,
        borderLeftColor: '#ccc',
        paddingLeft: 8,
        marginVertical: 8,
      }}
    >
      {children}
    </View>
  ),
};
